import React from 'react';
import * as Yup from 'yup';

import { Form } from '@dashboard/components/Formik';

import useProduct from '../../useProduct';
import { useVariants } from './VariantsContext';

function ProductVariantsRequiredForm() {
  const { product, updateProduct } = useProduct();
  const { state: variants } = useVariants();

  if (variants.length === 0) {
    return null;
  }

  return (
    <>
      <Form
        autosave
        showState={false}
        initialValues={{
          variantsRequired: product.variantsRequired,
        }}
        validationSchema={Yup.object().shape({
          variantsRequired: Yup.boolean().required('Required'),
        })}
        fields={[
          {
            name: 'variantsRequired',
            type: 'checkbox',
            label: 'Customer must select at least one variant option',
          },
        ]}
        onSubmit={async values => {
          try {
            const { data } = await updateProduct.mutateAsync(values);

            return { data };
          } catch (error) {
            return { error };
          }
        }}
      />
    </>
  );
}

export default ProductVariantsRequiredForm;
